import { render } from "./AppCopyright.vue?vue&type=template&id=6a8a3204&scoped=true"
import script from "./AppCopyright.vue?vue&type=script&lang=js"
export * from "./AppCopyright.vue?vue&type=script&lang=js"

import "./AppCopyright.vue?vue&type=style&index=0&id=6a8a3204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8a3204"]])

export default __exports__